module.exports = __webpack_public_path__ + "img/syrenis-black.a47d2c0f.png";